import React from 'react';
import { HubShell } from '../../components/hub/shell';
import EffortContent from '../../components/hub/effort/EffortContent';

/**
 * Effort inside the ClientHub HubShell: selecting "Effort" in the hub sidebar keeps
 * the page in the hub's own right-hand column (sidebar + top bar stay in view),
 * instead of dropping out to the legacy dashboard chrome. The identical surface also
 * renders in that dashboard chrome via <EffortPage>; both wrappers stay thin because
 * the page logic lives in the shared <EffortContent>.
 */
export default function EffortHubPage() {
  return (
    <HubShell>
      <EffortContent />
    </HubShell>
  );
}
